/*
================================================
Une mixin qui permet de déclencher des actions de marketing automation dans le backend
Le tracking des contact dans mautic n'est actif que si VUE_APP_ENABLE_MAUTIC_CONTACT_TRACKING vaut "true"

Les envois asynchrones sont inspirés de https://stackoverflow.com/a/50872395/666416

================================================
*/

var MarketingAutomationMixin = {

    methods: {


        /**
         * Envoi au backend le signal pour créer un contact et une company dans mautic
         * (déclenché par un signup)
         * @param self
         * @return {Promise<void>}
         */
        replicateSignup: async function (self) {

            if (process.env.VUE_APP_ENABLE_MAUTIC_CONTACT_TRACKING=="true") {

                try {
                    const params = {}
                    let response = await self.$http.post(`/marketing/automation/signup/users/${JSON.parse(this.$cookie.get('auth')).userSlug}`,
                        params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    return response

                } catch (error) {
                }
            }
        },


        /**
         * Envoi au backend le signal pour créer les contacts invités dans mautic
         * (déclenché par l'invitation d'utilisateur)
         * @param self
         * @param $usersEmail An array of users formated like :
          {
                "users_created": [
                    "struss@bulls.com",
                    "harisson@bulls.com"
                ]
            } Identique au retour lors de l'invitaion des users dans ModlaUserMangementComp.sendCreateQuery | @see (Backend) marketingAutomationSignupInvitAction

         * @return {Promise<void>}
         */
        replicateInvitUsers: async function (self, $usersEmail) {

            if (process.env.VUE_APP_ENABLE_MAUTIC_CONTACT_TRACKING=="true") {

                try {
                    const params = {"users_created": $usersEmail.users_created}
                    let response = await self.$http.post(`/marketing/automation/invit/users`,
                        params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    return response

                } catch (error) {
                }
            }
        },

        /**
         * Envoi au backend le signal pour créer un contact et l'ajouté dans sa company dans mautic
         * (déclenché par un signup depuis invit)
         * @param self
         * @return {Promise<void>}
         */
        replicateSignupInvit: async function (self) {

            if (process.env.VUE_APP_ENABLE_MAUTIC_CONTACT_TRACKING=="true") {

                try {
                    const params = {}
                    let response = await self.$http.post(`/marketing/automation/signup/invit/user/${JSON.parse(this.$cookie.get('auth')).userSlug}`,
                        params,
                        {headers: {Authorization: self.$auth.header()}}
                    )
                    return response

                } catch (error) {
                    // console.log(error);
                }
            }
        },

    }



}

export default MarketingAutomationMixin;
